const blockedParticipantCompanies: Set<string> = new Set(['cgos'])

export default blockedParticipantCompanies
